module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Thank you for your reservation","reservationProcessed":"You will receive an e-mail to confirm it.","loading":"Processing reservation…<br>Please wait."}}')
  delete Component.options._Ctor
}
